﻿import {UpdateHolderArguments} from "../../types/arguments/UpdateHolderArguments";
import IPermitsHolder from "../IPermitsHolder";
import {PermitsFrontClient} from "./PermitsFrontClient";

export class PermitsHolder implements IPermitsHolder {
	_client: PermitsFrontClient;

	constructor(client: PermitsFrontClient) {
		this._client = client;
	}

	update(data: UpdateHolderArguments, signal?: AbortSignal | undefined): Promise<void> {
		return this._client.nullFetch("holders", "PUT", data, {
			signal: signal
		});
	}
}
